// **********************************************************
// Timeline Module
// **********************************************************

const timelineModule = document.querySelectorAll('[data-slider="timeline-slider"]');

const timelineModuleOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
};

const initTimelineSlider = () => {
  timelineModule.forEach((el) => {
    const parent = el.closest('[data-slider-parent]');

    if (windowWidth() > 767) {
      const sliderEle = new Swiper(el, timelineModuleOptions);
      swiperLockClass(el, sliderEle);
    } else {
      enableScrollbarSync(parent);
    }
  });
};

initTimelineSlider();

setupResponsiveSliders({
  sliderElements: timelineModule,
  breakpoint: 767,
  initSlider: initTimelineSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
